<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left active" style="justify-content: center">
      <router-link to="/dashboard" class="logo logo-normal">
        <img :src="logoUrl" alt="" />
      </router-link>
      <router-link to="/dashboard" class="logo logo-white">
        <img :src="logoWhiteUrl" alt="" />
      </router-link>
      <router-link to="/dashboard" class="logo-small">
        <img :src="logoSmallUrl" alt="" />
      </router-link>
      <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
        <vue-feather type="chevrons-left"></vue-feather>
      </a>
    </div>
    <!-- /Logo -->

    <a
      id="mobile_btn"
      class="mobile_btn"
      href="javascript:void(0);"
      @click="toggleSidebar1"
    >
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>

    <!-- Header Menu -->
    <ul class="nav user-menu d-flex justify-content-end">
      <li class="nav-item dropdown has-arrow main-drop">
        <a
          href="javascript:void(0);"
          class="dropdown-toggle nav-link userset"
          data-bs-toggle="dropdown"
        >
          <span class="user-info">
            <span class="user-letter">
              <img
                :src="userProfileImage || defaultAvatarUrl"
                alt=""
                class="img-fluid user-avatar-img"
              />
            </span>
            <span class="user-detail">
              <span class="user-name">{{
                currentUser?.nom_utilisateur || "User"
              }}</span>
              <span class="user-role">{{ currentUser?.role || "" }}</span>
            </span>
          </span>
        </a>
        <div class="dropdown-menu menu-drop-user">
          <div class="profilename">
            <div class="profileset">
              <span class="user-img">
                <img
                  :src="userProfileImage || defaultAvatarUrl"
                  alt=""
                class="user-avatar-img"
                />
                <span class="status online"></span>
              </span>
              <div class="profilesets">
                <h6>{{ currentUser?.nom_utilisateur || "User" }}</h6>
                <h5>{{ currentUser?.role || "" }}</h5>
              </div>
            </div>
            <hr class="m-0" />
            <router-link class="dropdown-item" to="/profile">
              <vue-feather class="me-2" type="user"></vue-feather> Mon
              Profil</router-link
            >
            <router-link class="dropdown-item" to="/societe"
              ><vue-feather class="me-2" type="settings"></vue-feather
              >Paramètres</router-link
            >
            <hr class="m-0" />
            <a
              class="dropdown-item logout pb-0"
              href="#"
              @click.prevent="logoutUser"
            >
              <img :src="logoutIconUrl" class="me-2" alt="img" />Déconnexion
            </a>
          </div>
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:void(0);"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa fa-ellipsis-v"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/profile"
          >Mon Profil</router-link
        >
        <router-link class="dropdown-item" to="/societe"
          >Paramètres</router-link
        >
        <a class="dropdown-item" href="#" @click.prevent="logoutUser"
          >Déconnexion</a
        >
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

</template>

<script>
import { logout, getCurrentUser } from "@/services/authService";
import { getEmployeesData } from "@/services/emplooyesService";
import { toast } from "vue3-toastify";

export default {
  data() {
    return {
      currentUser: null,
      userProfileImage: null,
      // Fixed asset URLs
      logoUrl: require("@/assets/img/logo.png"),
      logoWhiteUrl: require("@/assets/img/logo-white.png"),
      logoSmallUrl: require("@/assets/img/logo-small.png"),
      defaultAvatarUrl: require("@/assets/img/profiles/avatar-01.jpg"),
      logoutIconUrl: require("@/assets/img/icons/log-out.svg"),
      profileImageListener: null,
    };
  },
  async mounted() {
    this.initMouseoverListener();
    this.currentUser = getCurrentUser();
    await this.loadUserProfileImage();
    this.profileImageListener = (event) => this.handleProfileImageUpdate(event);
    window.addEventListener("profile-image-updated", this.profileImageListener);
  },
  beforeUnmount() {
    if (this.profileImageListener) {
      window.removeEventListener(
        "profile-image-updated",
        this.profileImageListener
      );
    }
    document.removeEventListener("mouseover", this.handleMouseover);
  },
  watch: {
    $route() {
      this.closeMobileSidebar();
    },
  },
  methods: {
    normalizeImageUrl(path) {
      if (!path) return null;
      if (/^https?:\/\//i.test(path)) return path;
      const baseUrl = process.env.VUE_APP_URL || window.location.origin;
      const sanitizedBase = baseUrl.endsWith("/")
        ? baseUrl.slice(0, -1)
        : baseUrl;
      const sanitizedPath = path.startsWith("/")
        ? path
        : `/${path}`;
      return `${sanitizedBase}${sanitizedPath}`;
    },
    async loadUserProfileImage() {
      try {
        if (!this.currentUser?.user_id) return;

        // Get user data to check if they have a profile image
        const users = await getEmployeesData();
        const user = users.find((user) => user.id === this.currentUser.user_id);

        if (user && user.profile_image) {
          this.userProfileImage = this.normalizeImageUrl(
            `/storage/${user.profile_image}`
          );
        } else {
          this.userProfileImage = null;
        }
      } catch (error) {
        console.error("Error loading profile image in header:", error);
        // If there's an error loading the profile image, use default
        this.userProfileImage = null;
        const msg =
          (error && error.response && (error.response.data?.error || error.response.data?.message)) ||
          error.message ||
          "Erreur lors du chargement de l'image de profil";
        toast.error(msg);
      }
    },
    handleProfileImageUpdate(event) {
      const detail = event?.detail || {};
      const imageUrl =
        this.normalizeImageUrl(detail.imageUrl) ||
        this.normalizeImageUrl(
          detail.profileImagePath ? `/storage/${detail.profileImagePath}` : ""
        );
      this.userProfileImage = imageUrl || null;
    },

    toggleSidebar1() {
      const body = document.body;
      const willOpen = !body.classList.contains("slide-nav");
      if (willOpen) {
        body.classList.add("slide-nav", "menu-opened");
      } else {
        body.classList.remove("slide-nav", "menu-opened");
      }
    },
    toggleSidebar() {
      const body = document.body;
      const willEnableMini = !body.classList.contains("mini-sidebar");
      body.classList.toggle("mini-sidebar");
      if (willEnableMini) {
        body.classList.remove("expand-menu");
        this.slideUpSubmenu();
        window.dispatchEvent(new CustomEvent("collapse-side-menus"));
      }
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    closeMobileSidebar() {
      const body = document.body;
      if (window.innerWidth <= 1024) {
        body.classList.remove("slide-nav");
        body.classList.remove("menu-opened");
      }
    },

    initMouseoverListener() {
      document.addEventListener("mouseover", this.handleMouseover);
    },
    handleMouseover(e) {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        this.isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          this.slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          this.slideUpSubmenu();
        }

        e.preventDefault();
      }
    },
    isElementVisible(element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    },
    slideDownSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "block";
        }
      }
    },
    slideUpSubmenu() {
      const subdropPlusUl = document.getElementsByClassName("subdrop");
      for (let i = 0; i < subdropPlusUl.length; i++) {
        const submenu = subdropPlusUl[i].nextElementSibling;
        if (submenu && submenu.tagName.toLowerCase() === "ul") {
          submenu.style.display = "none";
        }
      }
    },
    async logoutUser() {
      await logout();
      this.$router.push({ path: "/" });
    },

    // Method to refresh profile image when updated from profile page
    refreshProfileImage() {
      this.loadUserProfileImage();
    },
  },
};
</script>

<style scoped>
.user-avatar-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #f5f7fb;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

@media (max-width: 576px) {
  .user-avatar-img {
    width: 40px;
    height: 40px;
  }
}
</style>
